import { useMemo, useState, useEffect } from 'react';

export function useImagesLoaded(urls=[]){
    const [checking, setChecking] = useState(false);
    const [loadedCount, setLoadedCount] = useState(0);
    const filteredUrls = (urls || []).filter((v)=> v && v.length);

    useEffect(() => {
        if(!checking && filteredUrls && filteredUrls.length) {
            filteredUrls.forEach((url)=> {
                const img = new Image();
                img.onload = ()=> setLoadedCount((l)=> l + 1);
                img.onerror = ()=> setLoadedCount((l)=> l + 1);
                img.src = url;
            });
            setChecking(true);
        }
    }, [filteredUrls, checking]);

    const loaded = useMemo(()=> {
        return loadedCount >= filteredUrls.length;
    }, [loadedCount, filteredUrls]);

    return loaded;
}
